import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { CalendarBlank, Wallet, CreditCard } from '@phosphor-icons/react';
import { subscriptionsAPI, formatApiError } from '../../services/api';
import { toast } from 'sonner';

export function SubscriptionSection({ product, productId, isAuthenticated, formatCurrency, navigate }) {
  const [subscribing, setSubscribing] = useState(false);

  const handleSubscribe = async (method) => {
    if (!isAuthenticated) { toast.error('Please login to subscribe'); navigate('/login'); return; }
    setSubscribing(true);
    try {
      const { data } = await subscriptionsAPI.subscribe(productId, method, window.location.origin);
      if (data.url) {
        window.location.href = data.url;
      } else {
        toast.success('Subscribed successfully!');
      }
    } catch (error) { toast.error(formatApiError(error)); }
    finally { setSubscribing(false); }
  };

  const minMonths = product.min_commitment_months || 3;

  return (
    <Card className="mt-4 bg-[#0D1F17] border border-[#22C55E]/20 rounded-sm shadow-none" data-testid="subscription-section">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <CalendarBlank className="w-5 h-5 text-[#22C55E]" weight="fill" />
          <span className="text-sm font-bold text-white">Subscribe</span>
        </div>
        <div className="bg-[#111111] rounded-sm p-4 mb-4">
          <div className="flex items-baseline justify-between">
            <p className="text-2xl font-bold text-[#22C55E]" style={{ fontFamily: 'Cabinet Grotesk' }}>{formatCurrency(product.price)}<span className="text-sm font-normal text-[#999999]">/mo</span></p>
            <span className="text-xs text-[#999999]">Min {minMonths} months</span>
          </div>
        </div>
        <p className="text-xs text-[#999999] mb-4">Choose your payment method. You'll be billed {formatCurrency(product.price)} monthly for a minimum of {minMonths} months.</p>
        <div className="space-y-2">
          <Button onClick={() => handleSubscribe('wallet')} disabled={subscribing} className="w-full bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-sm h-11 font-semibold" data-testid="subscribe-wallet-btn">
            <Wallet className="w-4 h-4 mr-2" />
            {subscribing ? 'Processing...' : 'Pay with Wallet'}
          </Button>
          <Button onClick={() => handleSubscribe('stripe')} disabled={subscribing} variant="outline" className="w-full border-[#22C55E]/30 hover:bg-[#22C55E]/10 text-[#22C55E] rounded-sm h-11 font-semibold" data-testid="subscribe-stripe-btn">
            <CreditCard className="w-4 h-4 mr-2" />
            {subscribing ? 'Processing...' : 'Pay with Card'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
